// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
export type TrustAdvisorsList_TrustAdvisorPartyFragment = { __typename?: 'TrustAdvisor', id: string, individual?: { __typename?: 'ClientProfile', displayName: string, lastName: string, id: string } | null, organization?: { __typename?: 'ClientOrganization', name: string, id: string } | null };

export type TrustAdvisorsList_TrustAdvisorFragment = (
  { __typename?: 'TrustAdvisor', id: string, level: Types.TrustAdvisorLevel, note?: string | null, roles?: Array<{ __typename?: 'TrustAdvisorRole', id: string, kind: Types.TrustAdvisorRoleKind }> | null }
  & TrustAdvisorsList_TrustAdvisorPartyFragment
);

export const Operations = {
  Fragment: {
    TrustAdvisorsList_TrustAdvisorParty: 'TrustAdvisorsList_TrustAdvisorParty' as const,
    TrustAdvisorsList_TrustAdvisor: 'TrustAdvisorsList_TrustAdvisor' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const TrustAdvisorsList_TrustAdvisorPartyFragmentDoc = gql`
    fragment TrustAdvisorsList_TrustAdvisorParty on TrustAdvisor {
  id
  individual {
    displayName
    lastName
    id
  }
  organization {
    name
    id
  }
}
    `;
export const TrustAdvisorsList_TrustAdvisorFragmentDoc = gql`
    fragment TrustAdvisorsList_TrustAdvisor on TrustAdvisor {
  id
  level
  note
  roles {
    id
    kind
  }
  ...TrustAdvisorsList_TrustAdvisorParty
}
    ${TrustAdvisorsList_TrustAdvisorPartyFragmentDoc}`;